import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from "react-i18next";
export var Tab = function () {
    var _a;
    var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
    var t = useTranslation(['public-room']).t;
    return (_jsx(React.Fragment, { children: _jsxs("ul", { className: "pr-tabs", children: [_jsx("li", { children: _jsx("a", { href: "/".concat(langCode, "/chat"), children: t("Messagerie") }) }), _jsx("li", { children: _jsx("div", { className: "active", children: t("Salles publiques") }) })] }) }));
};
